import {Injectable} from '@angular/core';

import {HttpClient, HttpHeaders, HttpParams} from '@angular/common/http';
import {Observable, of} from "rxjs";
import {map} from "rxjs/operators";

@Injectable({
  providedIn: 'root'
})
export class AllService {

  constructor(private http: HttpClient) {
  }

  getAllByItem(url: string) {
    let params = new HttpParams();
    params = params.append('profile', "null");
    return this.http.get(url, {params:params});
  }

  getItems(url: string, profile: string) {
    let params = new HttpParams();
    params = params.append('profile', profile);
    return this.http.get(url, {params:params});
  }

  getItemsCategories(url: string, param: any) :Observable<any>{
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'X-Custom-Header': JSON.stringify(param)
    });

    return this.http.get(url, {
      headers: headers,
      responseType: 'json', // The response type should match the format of the data being streamed
      reportProgress: true
    });
  }

  getCounties(url: string, param: string) {
    return this.http.get(url + param);
  }

  getSearchItem(url: string, itemName : string) {
    let params = new HttpParams();
    params = params.append('itemName', itemName);
    return this.http.get(url + '/item/category', {params:params});
  }

  getSearchCategories(url: string, category : string, subcategory : string) {
    let params = new HttpParams();
    params = params.append('category', category);
    params = params.append('subcategory', subcategory);
    params = params.append('profile', "null");
    return this.http.get(url + '/item/categories', {params:params});
  }

  getSearchCategoriesProfile(url: string, category : string, subcategory : string, profile : string) {
    let params = new HttpParams();
    params = params.append('category', category);
    params = params.append('subcategory', subcategory);
    params = params.append('profile', profile);
    return this.http.get(url + '/item/categories', {params:params});
  }



 /* getSearchCategoriesProfile(url: string, category : string, subcategory : string, profile: string) {
    let params = new HttpParams();
    params = params.append('category', category);
    params = params.append('subcategory', subcategory);
    params = params.append('profile', profile);
    return this.http.get(url + '/item/categories', {params:params});
  }*/
  /** GET with filter payload in X-Data header (listings search, sidebar, etc.). */
  getWithDataHeader(url: string, params: any): Observable<any> {
    const encodedFilter = btoa(JSON.stringify(params));
    return this.http.get<any>(url, {
      headers: {'X-Data': encodedFilter}
    });
  }

  searchLocations(query: string | any): Observable<any[]> {
    // Convert to string if it's an object
    const searchQuery = typeof query === 'string' ? query : (query?.name || '');

    if (!searchQuery || searchQuery.length < 2) {
      return of([]);
    }

    return this.http.get<any>('assets/data/airport.json').pipe(
      map(airports => {
        const firstAirport = Object.values(airports)[0];
        console.log('Airport structure:', firstAirport);

        return Object.values(airports)
          .filter((a: any) =>
            a.iata &&
            (a.name.toLowerCase().includes(searchQuery.toLowerCase()) ||
              a.city.toLowerCase().includes(searchQuery.toLowerCase()) ||
              a.iata.toLowerCase().includes(searchQuery.toLowerCase()))
          )
          .slice(0, 10)
          .map((a: any) => ({
            id: a.iata,
            name: `${a.name} (${a.iata})`,
            iataCode: a.iata,
            city: a.city,
            country: a.country,
            lat: a.lat || a.latitude,  // Try both field names
            lon: a.lon || a.longitude
          }));
      })
    );
  }
}
